import { expected } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { RentalFeatureGridModule } from '../../modules/featureGrid/RentalFeatureGridModule.tsx';
import { PropertyComparisonGridSyncDriver } from '../OrderSync/PropertyComparisonGridSyncDriver.tsx';

export const RentalFeatureGridRouteElement = () => {
  const orderId = expected(useParams().orderId);

  return (
    <PropertyComparisonGridSyncDriver orderID={orderId}>
      <ModuleContainer moduleID="rental-comparables" compact>
        <RentalFeatureGridModule />
      </ModuleContainer>
    </PropertyComparisonGridSyncDriver>
  );
};
